import { useState } from 'react';
import Drawer from '@/components/ui/Drawer/Drawer';
import { useDevMode, disableDevMode } from '@/hooks/useDevMode';
import { useDevSettings } from '@/hooks/useDevSettings';
import { candidateStore } from '@/lib/candidate-store';
import styles from './DevDrawer.module.css';

export default function DevDrawer() {
  const isDev = useDevMode();
  const { settings, update, reset } = useDevSettings();
  const [open, setOpen] = useState(false);

  if (!isDev) return null;

  return (
    <>
      <button
        type="button"
        className={styles.pill}
        onClick={() => setOpen(true)}
        aria-label="開発者設定を開く"
      >
        dev
      </button>

      <Drawer open={open} onClose={() => setOpen(false)} title="開発者設定">
        <div className={styles.body}>
          <label className={styles.field}>
            <span className={styles.fieldLabel}>API Base</span>
            <input
              type="text"
              className={styles.input}
              value={settings.apiBase}
              placeholder="http://localhost:8000"
              onChange={(e) => update({ apiBase: e.target.value.trim() })}
              spellCheck={false}
            />
            <span className={styles.fieldHint}>
              空欄の場合: 同オリジン (production) / VITE_API_BASE (dev)
            </span>
          </label>

          <label className={styles.checkbox}>
            <input
              type="checkbox"
              checked={settings.mock}
              onChange={(e) => update({ mock: e.target.checked })}
            />
            <span>モック応答で確認する</span>
          </label>

          <label className={styles.checkbox}>
            <input
              type="checkbox"
              checked={settings.fullLayer}
              onChange={(e) => update({ fullLayer: e.target.checked })}
            />
            <span>不動産情報ライブラリの全レイヤを取得する</span>
          </label>

          <div className={styles.actions}>
            <button
              type="button"
              className={styles.secondaryBtn}
              onClick={() => candidateStore.clear()}
            >
              候補地ストレージを消す
            </button>
            <button
              type="button"
              className={styles.secondaryBtn}
              onClick={reset}
            >
              この設定を初期化
            </button>
            <button
              type="button"
              className={styles.dangerBtn}
              onClick={() => {
                disableDevMode();
                setOpen(false);
              }}
            >
              dev モードを終了
            </button>
          </div>

          <p className={styles.help}>
            URL に <code>?dev=1</code> を付与すると dev モードが有効になります。
            <code>?dev=0</code> で解除できます。
          </p>
        </div>
      </Drawer>
    </>
  );
}
